/* eslint-disable @typescript-eslint/no-explicit-any */
import { useAppDispatch, useAppSelector } from '@/app/hooks';
import { HeaderPlaylist } from '@/components/atoms/HeaderPlaylist';
import { TrackItem } from '@/components/molecules/TrackItem';
import {
  getFavoritesFirebase,
  selectFavorite
} from '@/features/favorite/favoriteSlice';
import { useEffect, useRef } from 'react';
import heartImage from '@/assets/img/heart-image.png';
import { motion } from 'framer-motion';
import './favorites.scss';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuthStore } from '@/zustand/useAuthGoogle';
import { Spinner } from '@/components/atoms/Spinner';

export const Favorites = () => {
  const {
    favoriteTracks,
    status: { favoriteTracksState }
  } = useAppSelector(selectFavorite);
  const navigation = useRef<HTMLDivElement>(null);
  const { user: userGoogle } = useAuthStore((state) => state);
  const { t } = useTranslation();
  const router = useNavigate();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!userGoogle) return;
    dispatch(getFavoritesFirebase(userGoogle?.uid));
  }, [dispatch, userGoogle]);

  return (
    <main className='p-favorite' ref={navigation}>
      <motion.main
        layout
        initial={{ opacity: 0 }}
        animate={{ opacity: 1, scrollBehavior: 'smooth' }}
        transition={{ duration: 0.5, ease: 'easeInOut' }}>
        <HeaderPlaylist
          image={heartImage}
          navigation={navigation}
          name='dd'
          title={t('favorites.like') || 'Favorites'}
        />

        {!favoriteTracks.items.length && favoriteTracksState !== 'loading' && (
          <div className='p-favorite__empty'>
            <h1 className='p-favorite__empty-title'>{t('favorites.title')}</h1>
            <h2 className='p-favorite__empty-subtitle'>
              {t('favorites.empty')}
            </h2>
            <button
              onClick={() => router('/search')}
              className='p-favorite__empty-btn'>
              {t('favorites.button')}
            </button>
          </div>
        )}
        {favoriteTracksState === 'loading' ? (
          <Spinner height='auto' />
        ) : (
          <div className='p-favorite__full'>
            <h1 className='p-favorite__title'>{t('favorites.like')}</h1>
            <p className='p-favorite__count'>
              {favoriteTracks.items.length} {t('favorites.songs')}
            </p>
          </div>
        )}

        {favoriteTracksState !== 'loading' && (
          <section className='p-favorite__items'>
            <TrackItem tracks={favoriteTracks} />
          </section>
        )}
      </motion.main>
    </main>
  );
};
